export default [
  {
    path: "/customer/locations",
    name: "EnterpriseUserLocations",
    component: () => import("@/views/EnterpriseCustomer/Locations/index.vue"),
  },
];
